import { useEffect, useState } from "react";
import { applyServiceBaseUrlToOpenApiSpec } from "../config/sandboxDomains";
import { useI18n } from "../i18n/I18nContext";
import { translateOpenApiSpec } from "../i18n/openApiTranslations";

export const useOpenApiSpec = (url, providedSpec = null, service = null) => {
    const { language, t } = useI18n();
    const [spec, setSpec] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(!providedSpec);

    useEffect(() => {
        let active = true;

        if (providedSpec) {
            setSpec(translateOpenApiSpec(applyServiceBaseUrlToOpenApiSpec(providedSpec, service), language));
            setError("");
            setLoading(false);
            return () => {
                active = false;
            };
        }

        setSpec(null);
        setError("");
        setLoading(true);

        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(t("contract.fetchStatusError").replace("{status}", response.status));
                }
                return response.json();
            })
            .then((payload) => {
                if (active) setSpec(translateOpenApiSpec(applyServiceBaseUrlToOpenApiSpec(payload, service), language));
            })
            .catch((fetchError) => {
                if (active) setError(fetchError.message || t("contract.fetchError"));
            })
            .finally(() => {
                if (active) setLoading(false);
            });

        return () => {
            active = false;
        };
    }, [language, providedSpec, service, t, url]);

    return { error, loading, spec };
};
